import styles from '../../../styles/modules/promotion/referral/ReferralAbout.module.scss';

const ReferralAbout = () => {
  return (
    <section className="block" id="about">
      <div className="fixed">
        <div className={styles.about}>
          <div className={styles.aboutItem}>
            <div className={styles.aboutItemTitle}>до 5000 ₽</div>
            <div className={styles.aboutItemDescription}>
              за каждого друга, кто воспользуется твоей ссылкой
            </div>
            <div className={styles.aboutItemTip}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="328"
                height="21"
                viewBox="0 0 328 21"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinejoin="round"
              >
                <path d="M1.5 18L38.7236 3.93775C43.7014 2.05724 49.2234 2.23793 54.0677 4.43986L76.3138 14.5517C81.808 17.0491 88.1361 16.9319 93.5341 14.2329L111.813 5.09358C117.012 2.49418 123.084 2.28504 128.449 4.52059L153.96 15.1502C159.088 17.2865 164.872 17.1944 169.929 14.896L191.877 4.91962C197.335 2.43863 203.618 2.53719 208.996 5.18815L227.896 14.5052C233.048 17.0448 239.043 17.2469 244.354 15.06L271.325 3.95452C275.941 2.05386 281.1 1.94807 285.79 3.65793L326.5 18.5" />
              </svg>
            </div>
          </div>
          <div className={styles.aboutItem}>
            <div className={styles.aboutItemTitle}>приглашения для всех</div>
            <div className={styles.aboutItemDescription}>
              можно пригласить одного друга или большую компанию – ограничений нет
            </div>
            <div className={styles.aboutItemTip}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="328"
                height="21"
                viewBox="0 0 328 21"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinejoin="round"
              >
                <path d="M1.5 18L38.7236 3.93775C43.7014 2.05724 49.2234 2.23793 54.0677 4.43986L76.3138 14.5517C81.808 17.0491 88.1361 16.9319 93.5341 14.2329L111.813 5.09358C117.012 2.49418 123.084 2.28504 128.449 4.52059L153.96 15.1502C159.088 17.2865 164.872 17.1944 169.929 14.896L191.877 4.91962C197.335 2.43863 203.618 2.53719 208.996 5.18815L227.896 14.5052C233.048 17.0448 239.043 17.2469 244.354 15.06L271.325 3.95452C275.941 2.05386 281.1 1.94807 285.79 3.65793L326.5 18.5" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferralAbout;
